<template>
    <div>
        <card-header title="Update ACH Payment Method" icon="fa-university" />

        <card-body>
            <card-list>
                <subheader-list-item icon="fa-university" title="ACH Payment Information" />

                <container-list-item padded no-border>
                    <div class="columns">
                        <div class="column">
                            <b-field label="Account Nickname" label-position="inside">
                                <b-input v-model="formData.nickname" placeholder="e.g., My Checking Account"></b-input>
                            </b-field>
                        </div>
                        <div class="column">
                            <b-field label="Account Type" label-position="inside">
                                <b-select v-model="formData.type" expanded>
                                    <option value="checking">Checking</option>
                                    <option value="savings">Savings</option>
                                </b-select>
                            </b-field>
                        </div>
                    </div>

                    <div class="columns">
                        <div class="column">
                            <b-field label="Routing Number" label-position="inside">
                                <b-input
                                    v-model="formData.routing"
                                    placeholder="9 Digits"
                                    maxlength="9"
                                    type="tel"
                                ></b-input>
                            </b-field>
                        </div>
                    </div>

                    <div class="columns">
                        <div class="column">
                            <b-field label="Account Number" label-position="inside">
                                <b-input
                                    v-model="formData.account"
                                    placeholder="Account number"
                                    type="tel"
                                ></b-input>
                            </b-field>
                        </div>
                    </div>

                    <div class="columns">
                        <div class="column">
                            <b-field label="Confirm Account Number" label-position="inside">
                                <b-input
                                    v-model="formData.accountConfirm"
                                    placeholder="Re-enter account number"
                                    type="tel"
                                ></b-input>
                            </b-field>
                        </div>
                    </div>
                </container-list-item>
            </card-list>
        </card-body>

        <card-footer class="pt-3 pb-3">
            <div class="columns">
                <div class="column">
                </div>
                <div class="column has-text-right">
                    <b-button
                        type="is-primary"
                        size="is-small"
                        @click="submit"
                        :disabled="!isFormValid || isSubmitting"
                        :loading="isSubmitting"
                    >
                        <i class="fas fa-save mr-2"></i>Update Payment Method
                    </b-button>
                </div>
            </div>
        </card-footer>
    </div>
</template>

<script>
    import CardHeader from "@/TIER/components/CardHeader";
    import CardBody from "@/TIER/components/CardBody";
    import CardList from "@/TIER/components/CardList";
    import CardFooter from "@/TIER/components/CardFooter";
    import ContainerListItem from "@/TIER/components/ContainerListItem";
    import SubheaderListItem from "@/TIER/components/SubheaderListItem";
    import {client as http} from '@/http_client';

    export default {
        components: {SubheaderListItem, ContainerListItem, CardFooter, CardList, CardBody, CardHeader},
        props: ['card', 'props'],
        data() {
            return {
                formData: {
                    nickname: '',
                    type: 'checking',
                    routing: '',
                    account: '',
                    accountConfirm: ''
                },
                isSubmitting: false
            };
        },
        computed: {
            isFormValid() {
                return (
                    this.formData.nickname &&
                    this.formData.routing &&
                    this.formData.routing.length === 9 &&
                    this.formData.account &&
                    this.formData.account === this.formData.accountConfirm &&
                    this.formData.account.length >= 4
                );
            }
        },
        methods: {
            submit() {
                if (!this.isFormValid) {
                    window.alert('Please fill in all fields correctly and ensure account numbers match.');
                    return;
                }

                this.$emit('loading', true);

                const payload = {
                    nickname: this.formData.nickname,
                    type: this.formData.type,
                    routing: this.formData.routing,
                    account: this.formData.account
                };

                http.post(`payment-plans/${this.props.planId}/update-payment-method`, payload, {force: true})
                    .then(response => {
                        this.$reloadCard('payment-plan', {planId: this.props.planId});
                        this.$closeCard(this.card);
                    })
                    .catch(err => {
                        console.error('Error updating payment method:', err);
                        window.alert(err.response?.data?.error || 'Failed to update payment method. Please try again.');
                        this.$emit('loading', false);
                    });
            }
        }
    };
</script>